module.exports = __webpack_public_path__ + "media/images/icons/material/error-9e015111dc8092742ee30f6a2f097ea9.svg";